import { ref, computed, reactive, readonly } from 'vue'
import { defineStore } from 'pinia'
import moment from 'moment'

enum gender {
  MALE = 'male',
  FEMALE = 'female'
}

export interface iUserProfile {
  id: number
  fullname: string
  email: string
  phone: string
  gender: gender
  job: string | null
  alamat: string
  npwp: string | null
  role: string
  last_login: moment.Moment | null
  created_at: moment.Moment | null
  reset_token: string | null
  reset_token_expired_at: moment.Moment | null
  instagram: string | null
  linkedin: string | null
  twitter: string | null
  link_others: string | null
  tiktok: string | null
  youtube: string | null
  short_bio: string | null
  thumbnail: string | null
}

export const userProfileStore = defineStore('userProfile', () => {
  const profile = reactive<iUserProfile>({
    id: 0,
    fullname: '',
    email: '',
    phone: '',
    gender: gender.MALE,
    job: null,
    alamat: '',
    npwp: null,
    role: 'personal',
    last_login: null,
    created_at: null,
    reset_token: null,
    reset_token_expired_at: null,
    instagram: null,
    linkedin: null,
    twitter: null,
    link_others: null,
    tiktok: null,
    youtube: null,
    short_bio: null,
    thumbnail: null
  } as iUserProfile)

  const getUserProfile = readonly(profile)

  const isSubAccount = computed(() => profile.role.includes('sub-account'))

  function setUserProfile(userProfileObject: iUserProfile) {
    profile.id = userProfileObject.id
    profile.fullname = userProfileObject.fullname
    profile.email = userProfileObject.email
    profile.phone = userProfileObject.phone
    profile.gender = userProfileObject.gender
    profile.job = userProfileObject.job
    profile.alamat = userProfileObject.alamat
    profile.npwp = userProfileObject.npwp
    profile.role = userProfileObject.role
    profile.last_login = userProfileObject.last_login
    profile.created_at = userProfileObject.created_at
    profile.reset_token = userProfileObject.reset_token
    profile.reset_token_expired_at = userProfileObject.reset_token_expired_at
    profile.instagram = userProfileObject.instagram
    profile.linkedin = userProfileObject.linkedin
    profile.twitter = userProfileObject.twitter
    profile.link_others = userProfileObject.link_others
    profile.tiktok = userProfileObject.tiktok
    profile.youtube = userProfileObject.youtube
    profile.short_bio = userProfileObject.short_bio
    profile.thumbnail = userProfileObject.thumbnail
  }

  return { getUserProfile, isSubAccount, setUserProfile }
})
